<!-- =========================================================================================
    File Name: FeatherIcon.vue
    Description: Feather icon component. Creates feather icon based on 'icon' prop
    Component Name: FeatherIcon
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<script>
import { h } from 'vue'
import * as icons from 'vue-feather-icons'

function legacyH(type, data = {}, children = []) {
    const props = {
        ...(data.attrs || {}),
        ...(data.domProps || {}),
    }

    if (data.class || data.staticClass) {
        props.class = [data.staticClass, data.class]
    }
    if (data.style || data.staticStyle) {
        props.style = [data.staticStyle, data.style]
    }
    if (data.on) {
        Object.entries(data.on).forEach(([event, handler]) => {
            props[`on${event.charAt(0).toUpperCase()}${event.slice(1)}`] = handler
        })
    }

    return h(type, props, children)
}

export default {
    name: 'feather-icon',
    inheritAttrs: false,
    props: {
        icon: { required: true },
        svgClasses: { type: [String, Object, Array], default: "" },
        badge: {},
        size: { type: [String, Number], default: "24" }
    },
    render() {
        const { class: rootClass, style, ...rootAttrs } = this.$attrs

        // Add feather classes
        const data = {
            ...rootAttrs,
            class: ['feather-icon select-none relative', rootClass],
            style,
        }

        const legacyIcon = icons[this.icon]
        let svg = legacyIcon?.render
            ? legacyIcon.render(legacyH, {
                props: { size: String(this.size) },
                data: { class: this.svgClasses },
                children: [],
            })
            : this.icon
                ? h('i', {
                    class: ['vs-icon notranslate icon-scale material-icons', this.svgClasses],
                  }, this.icon)
                : null
        let badgeEl = h('span', {
            class: 'feather-icon-badge bg-primary text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center',
            style: 'top: -7px; right: -5px'
        }, this.badge)
        let children = svg ? [svg] : []
        if(this.badge) children.push(badgeEl)
        return h('span', data, children)
    }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/featherIcon.scss"
</style>
